import type {
  CustomAttributeFieldType,
  FormFieldOption,
} from '@risksmart-app/shared/custom-attributes/types';
import { createContext } from 'react';

export type CurrentField = {
  Label: string;
  AltLabel?: string;
  Type: CustomAttributeFieldType;
  ShowAltValues: boolean;
  Options?: FormFieldOption[];
  Required: boolean;
  ReadOnly: boolean;
  Hidden: boolean;
  Description?: string;
};

export type CustomFieldState = {
  currentField: CurrentField;
  fieldPath: string;
};

export const CustomFieldContext = createContext<CustomFieldState | null>(null);
